import { Output, ChangeDetectionStrategy, Component, Input, ViewEncapsulation, EventEmitter } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { MoreMenu } from "./MoreMenu";
import { ModalName } from "../../modal/modal.map";
import { DynamicContentComponent } from "../../dynamic-content/dynamic.content.component";
import { S25HelpDirective } from "../../s25-help/s25.help.directive";
import { S25RouterLinkDirective } from "../s25.router.link.directive";

@TypeManagerDecorator("s25-ng-more-menu-item")
@Component({
    selector: "s25-ng-more-menu-item",
    template: `
        @if (item.modalName) {
            <a (click)="openModal(item.modalName)">{{ item.displayName }}</a>
        } @else if (item.state) {
            <a s25-ng-router-link [stateName]="item.state.name" (click)="itemClicked.emit()">{{ item.displayName }}</a>
        } @else if (item.url) {
            <a [href]="item.url" (click)="itemClicked.emit()">{{ item.displayName }}</a>
        } @else if (item.dynamicValue) {
            <s25-ng-dynamic-content [dynamicValue]="item.dynamicValue"></s25-ng-dynamic-content>
        }
    `,
    styles: [
        `
            a {
                display: block;
            }
        `,
    ],
    standalone: true,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DynamicContentComponent, S25RouterLinkDirective],
})
export class S25MoreMenuItemComponent {
    @Input() item: MoreMenu.MenuItem;
    @Output() itemClicked = new EventEmitter<void>();

    openModal(modalName: ModalName): void {
        //Using the JS modal service to open a modal until all modals are converted to Angular
        //When we convert a modal to angular it is a component so dynamic content makes more sense
        const ModalService = window.angBridge.$injector.get("s25ModalService");
        this.itemClicked.emit();
        ModalService.modal(modalName);
    }

    //This component gives us a central place for all possible components we might need as more menu items.
    /*
    The menu items are often
    - simple links eg. <a href="">
    - Modal components - they open a modal either via modal service or using a standalone modal component
    - state change link

    They can also be any other component. I think we'll be happiest if we have some pre built features, and an option to dynamically render the passed in component.
     */
}
